import { gql } from "apollo-angular";

export const QUALITATIVE_TABLE_FRAGMENT = gql`
  fragment QualitativeTableData on MacroSectionQuestions {
    sectionTitle
    sectionId
    sectionDescription
    sectionNumber
    questions {
      ansGrp {
        group
        id
      }
      id
      content
      questionOrder
    }
  }
`;

export const PAGINATED_QUALITATIVE_FRAGMENT = gql`
  fragment PaginatedFragment on QueryResponse {
    pageSize
    pageIndex
    totalPages
    totalElements
  }
`;

export const QUALITATIVE_TABLE_QUERY = gql`
  query GetQualitative($page: PagingInput) {
    macroSections(page: $page) {
      ...PaginatedFragment
      data {
        ...QualitativeTableData
      }
    }
  }
  ${PAGINATED_QUALITATIVE_FRAGMENT}
  ${QUALITATIVE_TABLE_FRAGMENT}
`;

export const DELETE_QUESTION = gql`
  mutation DeleteQuestion($id: ID!) {
    deleteQuestion(id: $id) {
      message
      pageIndex
      pageSize
      totalElements
      totalPages
      statusCode
      timestamp
    }
  }
`;

export const DELETE_SECTION = gql`
  mutation DeleteSection($id: ID!) {
    deleteMacroSection(id: $id) {
      data
      message
      statusCode
    }
  }
`;

export const CREATE_SECTION = gql`
  mutation CreateSection($input: MacroSectionInput!) {
    createMacroSection(input: $input) {
      data {
        description
        id
        name
      }
    }
  }
`;

export const CREATE_QUESTION = (
  answerGroupCategoryType: string,
  content: string,
  macSecId: number
) => gql`
  mutation CreateQuestion {
    createQuestion(input: 
    {
      answerGroupCategoryType: ${answerGroupCategoryType}, 
      content: ${JSON.stringify(content)}, 
      macSecId: ${macSecId}, 
    }) {
      data {
        ansGrp {
          id
        }
        content
      }
    }
  }
`;

export const UPDATE_QUESTION = (
  id: string,
  answerGroupCategoryType: string,
  content: string,
  macSecId: number,
  questionOrder: number
) => gql`
  mutation UpdateQuestion {
    updateQuestion(
      id: ${JSON.stringify(id)}
      input: 
    {
      answerGroupCategoryType: ${answerGroupCategoryType}, 
      content: ${JSON.stringify(content)}, 
      macSecId: ${macSecId}, 
      questionOrder: ${questionOrder}
    }) {
       data {
      questionOrder
      id
      content
      ansGrp {
        id
        group
      }
    }
      message
    pageIndex
    pageSize
    statusCode
    timestamp
    totalElements
    totalPages
    }
  }
`;
